module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/testimonials/jonah-garcia-b2f32e4e9640a5977daff7b843af47c1.png";